// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { createMonitoredFetch } from './healthMonitor';

const SUPABASE_URL = "https://tyfcsoapssjfnbrebyok.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5ZmNzb2Fwc3NqZm5icmVieW9rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxNDY4NTYsImV4cCI6MjA2MjcyMjg1Nn0.1vk0W_PBrf6nQcwJHcUAM6Ox_aBPL--RmoulXuFWSF8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  global: {
    fetch: createMonitoredFetch(),
  },
});